import apiFetch from '../apiFetch'

export default function (documentId, token) {
  return apiFetch({ endPoint: `documentHistorical/${documentId}/download`, method: 'GET', body: null, parseBlobAndAssign: true, token: token })
}
